import { TransactionType } from 'tennders-transactions/types/TransactionType'
import { TruckTypeType } from 'tennders-market/truck/types/TruckTypeType'

// My Board / Board View / Card
export const copyTextTransactionMyBoard = (transaction: TransactionType): string => {
  let text = ''

  const { pickupRoute } = transaction
  if (pickupRoute) {
    text += pickupRoute?.shortLabel ? `Pick-up: ${pickupRoute.shortLabel} \n` : ''
    text += pickupRoute?.date?.d ? `Pick-up Date: ${pickupRoute?.date?.d} \n` : ''
    text += pickupRoute?.date?.t ? `Pick-up Time: ${pickupRoute?.date?.t} \n` : ''
  }

  const { deliveryRoute } = transaction
  if (deliveryRoute) {
    text += deliveryRoute?.shortLabel ? `Delivery: ${deliveryRoute.shortLabel} \n` : ''
    text += deliveryRoute?.date?.d ? `${deliveryRoute?.date?.d} \n` : ''
    text += deliveryRoute?.date?.t ? `${deliveryRoute?.date?.t} \n` : ''
  }

  text += transaction?.distanceInKms ? `Distance: ${parseInt((transaction.distanceInKms / 1000).toString(), 10).toLocaleString('US')} km \n` : ''
  if (transaction?.matchedTruck?.truckPlate || transaction?.matchedTruck?.trailerPlate) {
    text += `Plates: ${transaction?.matchedTruck?.truckPlate ? transaction?.matchedTruck?.truckPlate : ''}
            ${transaction?.matchedTruck?.trailerPlate ? ' / ' + transaction?.matchedTruck?.trailerPlate : ''} \n`
  }
  return text
}

// My Board / Board View / BottomCardForBroker
export const copyPlatesMyBoardBoardView = (transaction: TransactionType | {
  matchedTruck : TruckTypeType
}): string => {
  let text = ''
  if (transaction?.matchedTruck?.truckPlate) {
    text += transaction?.matchedTruck?.truckPlate
  }
  if (transaction?.matchedTruck?.trailerPlate) {
    text += `/${transaction?.matchedTruck?.trailerPlate}`
  }

  return text
}

// Truck board
export const copyTextTruckBoard = (transaction: TransactionType) => {
  let text = transaction?.matchedTruck?.truckType?.label ? `Truck type: ${transaction.matchedTruck.truckType.label} \n` : ''

  const { pickupRoute } = transaction
  if (pickupRoute) {
    text += pickupRoute?.shortLabel ? `Pick-up: ${pickupRoute.shortLabel} \n` : ''
    text += pickupRoute?.date?.d ? `Pick-up Date: ${pickupRoute?.date?.d} \n` : ''
    text += pickupRoute?.date?.t ? `Pick-up Time: ${pickupRoute?.date?.t} \n` : ''
  }

  const { deliveryRoute } = transaction
  if (deliveryRoute) {
    text += deliveryRoute?.shortLabel ? `Delivery: ${deliveryRoute?.shortLabel} \n` : ''
    text += deliveryRoute?.date?.d ? `Delivery Date: ${deliveryRoute?.date?.d} \n` : ''
    text += deliveryRoute?.date?.t ? `Delivery Time: ${deliveryRoute?.date?.t} \n` : ''
  }

  return text
}

// Common Board
export const copyTextLoadBoard = (transaction: TransactionType) => {
  let text = ''

  const { pickupRoute } = transaction

  if (pickupRoute) {
    text += pickupRoute?.shortLabel ? `Pick-up: ${pickupRoute.shortLabel} \n` : ''
    text += pickupRoute?.date?.d ? `Pick-up Date: ${pickupRoute?.date?.d} \n` : ''
    text += pickupRoute?.date?.t ? `Pick-up Time: ${pickupRoute?.date?.t} \n` : ''
  }

  const { deliveryRoute } = transaction
  if (deliveryRoute) {
    text += deliveryRoute?.label ? `Delivery: ${deliveryRoute?.label} \n` : ''
    text += deliveryRoute?.date?.d ? `Delivery Date: ${deliveryRoute?.date?.d} \n` : ''
    text += deliveryRoute?.date?.t ? `Delivery Time: ${deliveryRoute?.date?.t} \n` : ''
  }
  text += transaction?.matchedLoad?.deliveryRoute?.instructions ? `Special Requirements: ${transaction?.matchedLoad?.deliveryRoute?.instructions}` : ''

  return text
}
